"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
const themed = key => props => {
  return props.theme[key];
};

exports.default = themed;